import { render, staticRenderFns } from "./workspace-question-set-view.vue?vue&type=template&id=aa49c652&scoped=true&"
import script from "./workspace-question-set-view.vue?vue&type=script&lang=js&"
export * from "./workspace-question-set-view.vue?vue&type=script&lang=js&"
import style0 from "./workspace-question-set-view.vue?vue&type=style&index=0&id=aa49c652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa49c652",
  null
  
)

export default component.exports